import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Menu } from "antd";
import { Link, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

const getOpenKeys = (string, collapsed) => {
  let newStr = "",
    newArr = [],
    arr = string.split("/").map((i) => "/" + i);
  for (let i = 1; i < arr.length - 1; i++) {
    newStr += arr[i];
    newArr.push(newStr);
  }
  return collapsed ? [] : newArr;
};

const findParentKeys = (menu, key) => {
  for (let item of menu) {
    if (item.key === key) return [];
    if (item.subs) {
      const found = findParentKeys(item.subs, key);
      if (found) return [item.key, ...found];
    }
  }
  return null;
};

const SideMenu = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    openKeys: [],
    selectedKeys: [],
  });

  let { openKeys, selectedKeys } = state;
  let menuProps = props.collapsed ? {} : { openKeys };

  useEffect(() => {
    let { pathname } = props.location;
    setState((prevState) => ({
      ...prevState,
      selectedKeys: [pathname],
      openKeys: getOpenKeys(pathname),
    }));
  }, [props.location]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    setState((prevState) => ({
      ...prevState,
      openKeys: latestOpenKey ? [latestOpenKey] : [],
    }));
  };

  const handleClick = ({ key }) => {
    const parentKeys = findParentKeys(props.menu, key) || [];
    setState((prevState) => ({
      ...prevState,
      selectedKeys: [key],
      openKeys: parentKeys,
    }));
  };

  // const renderMenuItem = ({ key, icon, title }) => (
  //   <Menu.Item key={key}>
  //     <Link to={key} replace>
  //       {icon}
  //       <span>{title}</span>
  //     </Link>
  //   </Menu.Item>
  // );
  const renderMenuItem = ({ key, icon, title }) => {
    const path = key == undefined ? "#" : key;
    const itemKey =
      key == undefined ? `menu-item-${Math.random().toString(36)}` : key;
    return (
      <Menu.Item key={itemKey}>
        <Link to={path} replace>
          {icon}
          <span>{title}</span>
        </Link>
      </Menu.Item>
    );
  };

  const renderSubMenu = ({ key, icon, title, subs }) => (
    <Menu.SubMenu
      key={key}
      title={
        <span>
          {icon}
          <span>{title}</span>
        </span>
      }
    >
      {subs &&
        subs.map((item) => {
          return item.subs && item.subs.length > 0
            ? renderSubMenu(item)
            : renderMenuItem(item);
        })}
    </Menu.SubMenu>
  );

  return (
    <Menu
      mode="inline"
      theme="light"
      {...menuProps}
      className="sidemenu-list"
      selectedKeys={selectedKeys}
      onClick={handleClick}
      onOpenChange={onOpenChange}
    >
      {props.menu &&
        props.menu.map((item) => {
          return item.subs && item.subs.length > 0
            ? renderSubMenu(item)
            : renderMenuItem(item);
        })}
    </Menu>
  );
};

SideMenu.propTypes = {
  menu: PropTypes.array.isRequired,
};

export default withRouter(SideMenu);
